import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { tableConfig } from '../../../../../../settings/index';
import Api from '../../../../../../helpers/api';
import { sendRequest } from '../../../../../../helpers/saga';
import { logger } from '../../../../../../helpers/logger';
import notifications from '../../../../../../redux/notifications/actions';

const workersApi = new Api('orientations/sessions/:id/shifts');
const ncnsApi = new Api('orientations/sessions/:id/shifts/no_call_no_show');

function* loadData({ payload }) {
  try {
    const {
      page = 1,
      pageSize = tableConfig.pageSize,
      column,
      order,
      filter = '',
      session_id,
      tab = 'worked',
    } = payload;

    let api = null;

    switch (tab) {
      case 'worked':
        api = workersApi;
        break;
      case 'ncns':
        api = ncnsApi;
        break;
      default:
        api = workersApi;
        break;
    }

    const result = yield call(
      sendRequest,
      api.load,
      { search: { page, pageSize, column, order, filter }, id: session_id },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data && result.data.success && result.data.success.data) {
      const { records, totalCount, filteredCount, sortable_columns, filters } = result.data.success.data;

      yield put(
        actions.loadDataSuccess({
          data: records,
          filters,
          page,
          pageSize,
          column,
          order,
          filter,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD_REQUEST, loadData)]);
}
